import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { RenderField, RenderCheckboxRadioField, RenderSubmitButton } from '../common/form';
import * as Validations from '../common/form/commonValidations';

import Onboarding1x from '../../assets/images/doodles/onboarding_1.png';
import Onboarding2x from '../../assets/images/doodles/onboarding_1@2x.png';

const DEFAULT_COPY = {
  hed: 'Welcome, this is the wedding of',
  hed_mobile: 'This is the wedding of',
  cta: 'Next Up: Date'
};

const Step1 = (props) => {
  const { handleSubmit, valid, overrideCopy, hideShopLink } = props;
  const stepCopy = { ...DEFAULT_COPY, ...overrideCopy };

  return (
    <div className="row">
      <div className="col-md-10 col-lg-8 col-md-offset-1 col-lg-offset-2 step-form" id="step-1">
        <img className="hidden-xs" src={Onboarding1x} srcSet={`${Onboarding2x} 2x`} alt="Zola Roses" />
        <h3 className="onboard-step-header hidden-xs">
          {stepCopy.hed}
          {stepCopy.dek && <p>{stepCopy.dek}</p>}
        </h3>
        <h3 className="onboard-step-header hidden visible-xs">
          {stepCopy.hed_mobile}
          {stepCopy.dek && <p>{stepCopy.dek}</p>}
        </h3>
        <form onSubmit={handleSubmit}>
          <div className="col-sm-5 text-left">
            <div className="row">
              <div className="col-xs-12"><label htmlFor="primaryFirstName">You are:</label></div>
              <div className="col-xs-6 col-xs-half-gutter-right">
                <Field
                  id="primaryFirstName"
                  placeholder="First Name"
                  name="owner_user_first_name"
                  type="text"
                  required
                  component={RenderField}
                  validate={Validations.REQUIRED}
                />
              </div>
              <div className="col-xs-6 col-xs-half-gutter-left">
                <Field
                  id="primaryLastName"
                  placeholder="Last Name"
                  name="owner_user_last_name"
                  type="text"
                  required
                  component={RenderField}
                  validate={Validations.REQUIRED}
                />
              </div>
            </div>
            <div className="text-center">
              <Field
                id="primaryRoleBride"
                name="owner_role"
                component={RenderCheckboxRadioField}
                type="radio"
                value="BRIDE"
                label="Bride"
                validate={Validations.REQUIRED}
                styleOverride
                inline
              />
              <Field
                id="primaryRoleGroom"
                name="owner_role"
                component={RenderCheckboxRadioField}
                type="radio"
                value="GROOM"
                label="Groom"
                validate={Validations.REQUIRED}
                styleOverride
                inline
              />
            </div>
          </div>
          <div className="col-sm-2">
            <div className="names-spacer-mobile" />
            <div className="and-join hidden-xs">AND</div>
          </div>
          <div className="col-sm-5 text-left">
            <div className="row">
              <div className="col-xs-12"><label htmlFor="partnerFirstName">Your spouse-to-be is:</label></div>
              <div className="col-xs-6 col-xs-half-gutter-right">
                <Field
                  id="partnerFirstName"
                  placeholder="First Name"
                  name="partner_user_first_name"
                  type="text"
                  required
                  component={RenderField}
                  validate={Validations.REQUIRED}
                />
              </div>
              <div className="col-xs-6 col-xs-half-gutter-left">
                <Field
                  id="partnerLastName"
                  placeholder="Last Name"
                  name="partner_user_last_name"
                  type="text"
                  required
                  component={RenderField}
                  validate={Validations.REQUIRED}
                />
              </div>
            </div>
            <div className="text-center">
              <Field
                id="partnerRoleBride"
                name="partner_role"
                component={RenderCheckboxRadioField}
                type="radio"
                value="BRIDE"
                label="Bride"
                validate={Validations.REQUIRED}
                styleOverride
                inline
              />
              <Field
                id="partnerRoleGroom"
                name="partner_role"
                component={RenderCheckboxRadioField}
                type="radio"
                value="GROOM"
                label="Groom"
                validate={Validations.REQUIRED}
                styleOverride
                inline
              />
            </div>
          </div>
          <div className="col-xs-12 next-button">
            <RenderSubmitButton valid={valid} className="btn btn-wide btn-primary" value={stepCopy.cta} />
          </div>
          {!hideShopLink
            && (
            <div className="col-xs-12">
              <a href="/shop/index" className="onboard-link-bold">I Just Want To Shop &rsaquo;</a>
            </div>
            )
          }
        </form>
      </div>
    </div>
  );
};

Step1.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  overrideCopy: PropTypes.shape({
    hed: PropTypes.string,
    dek: PropTypes.string,
    cta: PropTypes.string
  }),
  hideShopLink: PropTypes.bool
};

export default reduxForm({
  form: 'onboardForm',
  destroyOnUnmount: false
})(Step1);



// WEBPACK FOOTER //
// ./src/components/onboard/Step1.jsx